var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoBrandedCollaterals1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10265_14862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5923 30.0775V29.4139C26.0529 28.8671 26.333 28.1452 26.333 27.3553V26.5775C26.333 25.9285 26.164 25.3233 25.8724 24.8007C26.1293 24.6914 26.4094 24.633 26.7034 24.633C27.9302 24.633 28.9256 25.6782 28.9256 26.9664V27.7441C28.9256 28.3202 28.627 28.8233 28.1849 29.0907V30.0775H25.5923ZM17.8145 29.0907C17.3724 28.8233 17.0737 28.3202 17.0737 27.7441V26.9664C17.0737 25.6782 18.0691 24.633 19.296 24.633C19.59 24.633 19.87 24.6938 20.127 24.8007C19.8353 25.3209 19.6663 25.9285 19.6663 26.5775V27.3553C19.6663 28.1452 19.9464 28.8646 20.4071 29.4139V30.0775H17.8145V29.0907ZM19.296 20.7441C20.0112 20.7441 20.5923 21.3542 20.5923 22.1053C20.5923 22.8563 20.0112 23.4664 19.296 23.4664C18.5807 23.4664 17.9997 22.8563 17.9997 22.1053C17.9997 21.3542 18.5807 20.7441 19.296 20.7441ZM26.7034 20.7441C27.4187 20.7441 27.9997 21.3542 27.9997 22.1053C27.9997 22.8563 27.4187 23.4664 26.7034 23.4664C25.9881 23.4664 25.4071 22.8563 25.4071 22.1053C25.4071 21.3542 25.9881 20.7441 26.7034 20.7441ZM16.8886 31.2441H29.1108C29.4187 31.2441 29.6663 31.5042 29.6663 31.8275C29.6663 32.1507 29.4187 32.4108 29.1108 32.4108H16.8886C16.5807 32.4108 16.333 32.1507 16.333 31.8275C16.333 31.5042 16.5807 31.2441 16.8886 31.2441Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 21.4486C24.6667 20.6001 23.9193 19.9102 23 19.9102C22.0807 19.9102 21.3333 20.6001 21.3333 21.4486C21.3333 22.2972 22.0807 22.9871 23 22.9871C23.9193 22.9871 24.6667 22.2972 24.6667 21.4486Z",
    fill: "#F6948B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 28.8501C25.1693 28.54 25.5 28.0111 25.5 27.4102V26.4486C25.5 25.1746 24.3802 24.1409 23 24.1409C21.6198 24.1409 20.5 25.1746 20.5 26.4486V27.4102C20.5 28.0111 20.8307 28.54 21.3333 28.8501V29.9102H24.6667V28.8501Z",
    fill: "#F6948B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4893 14.8086L26.3867 15.459L28.0137 16.0596L27.1201 18.4834L25.5576 17.9062L25.6602 17.2559L23.7314 16.5439L23.1514 18.1152L23.3691 18.7051L23.0684 18.8154L22.9805 18.5781L22.8936 18.8154L22.5928 18.7051L22.8096 18.1152L22.2295 16.5439L20.3018 17.2559L20.4043 17.9062L18.8418 18.4834L17.9482 16.0596L19.5752 15.459L19.4717 14.8086L21.6367 14.0098L22.9805 17.6523L24.3252 14.0098L26.4893 14.8086Z",
    fill: "#013C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10265_14862",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10265_14862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10265_14862",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoBrandedCollaterals1);
export default __webpack_public_path__ + "static/media/Co-Branded Collaterals 1.643714e4b94d004b7545db14a446ec7e.svg";
export { ForwardRef as ReactComponent };